export default __webpack_public_path__ + "static/media/Mutual-aid.522ee257.png";